import { render, staticRenderFns } from "./aggrement.vue?vue&type=template&id=28c30f18&"
import script from "./aggrement.vue?vue&type=script&lang=js&"
export * from "./aggrement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports